export default __webpack_public_path__ + "static/media/projectPic.032e0321.jpg";